import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import ProgressiveImage from "react-progressive-image";
import Customization from "../../Items/Customization";

class ScrollItems extends Component {
    state = {
        tags: [],
        update: true
    };



    forceStateUpdate = () => {
		// setTimeout(() => {
		// 	this.forceUpdate();
		// 	if (this.state.update) {
		// 		this.setState({ update: false });
		// 	} else {
		// 		this.setState({ update: true });
		// 	}
		// }, 100);
		this.props.forceStateUpdate();
	};

    render() {

        // console.log(this.props.items);
        const { addProduct , removeProduct, cartProducts} = this.props;
        return (
            <React.Fragment >
                <div className="text-center scroll-items-parent">

                {this.props.items.map((item, index) => (
                    <div className="scroll-item">
                        <div className="add-item">
                           
                        </div>
                        <div>
                            <div className="image-parent ">
                                {cartProducts.find((cp) => cp.id === item.id) !== undefined
                                 && cartProducts.find((cp) => cp.id ===item.id).quantity > 0 &&
                                <div className="image-quantity-div">
                                 {cartProducts.find((cp) => cp.id ===item.id).quantity}
                                </div>
                                }
								<DelayLink to={`/single-store-single_item/${item.id}`}>
                                <img alt="yey" src={'https://pykin.in/'+item.image} style={{ width: '7rem', height: '7rem' }} />
								</DelayLink>
							</div>
                            <div className="items-text" style={{ textOverflow: 'ellipsis',overflowY: 'hidden' }}>{item.name}</div>
							<div className="items-sub" style={{ textOverflow: 'ellipsis',overflowY: 'hidden' }}>{item.short_desc}</div>

                            <div className="items-price" style={{ textOverflow: 'ellipsis',overflowY: 'hidden' }}>₹{item.price}</div>
                            <div className="add-item-switches">
                           {cartProducts.find((cp) => cp.id === item.id) !==
														undefined && (
														<React.Fragment>
															<div className="item-actions  mt-2">
																<div
																	className="btn-group btn-group-sm border "
																	role="group"
																	aria-label="btnGroupIcons1"
																	style={{borderRadius:'0.5rem'}}
																>
																	{item.is_active ? (
																		<React.Fragment>
																			{item.addon_categories.length ? (
																				<button
																					disabled
																					type="button"
																					className="btn btn-add-remove"
																					style={{
																						width: '2.7rem',

																						color: localStorage.getItem("cartColor-bg"),
																					}}
																				>
																					<span class="btn-dec">-</span>
																					<Ink duration="500" />
																				</button>
																			) : (
																				<button
																					type="button"
																					className="btn btn-add-remove"
																					style={{
																						width: '2.7rem',

																						color: localStorage.getItem("cartColor-bg"),
																					}}
																					onClick={() => {
																						item.quantity = 1;
																						removeProduct(item);
																						this.forceStateUpdate();
																					}}
																				>
																					<span class="btn-dec">-</span>	
																					<Ink duration="500" />
																				</button>
																			)}

																			

																			{item.addon_categories.length ? (
																				<Customization
																					product={item}
																					addProduct={addProduct}
																					forceUpdate={this.forceStateUpdate}
																				/>
																			) : (
																				<button
																					type="button"
																					className="btn btn-add-remove robo"
																					style={{
																						width: '2.7rem',

																						color: localStorage.getItem("cartColor-bg"),
																					}}
																					onClick={() => {
																						
																						addProduct(item);
																						this.forceStateUpdate();
																					}}
																				>
																					<span className="robo" style={{"fontSize":"1.4rem","lineHeight":"14px","color":"#282c3f","fontWeight":"500"}}>+</span>
																					<Ink duration="500" />
																				</button>
																			)}
																		</React.Fragment>
																	) : (
																		<div className="robo text-danger text-item-not-available">
																			{localStorage.getItem("cartItemNotAvailable")}
																		</div>
																	)}
																</div>
															</div>
														</React.Fragment>
													)}

													{cartProducts.find((cp) => cp.id === item.id) ===
														undefined && (
														<React.Fragment>
															<div className="item-actions mt-2">
																{item.is_active ? (
																	<React.Fragment>
																		{item.addon_categories.length ? (
																			<Customization
																				product={item}
																				addProduct={addProduct}
																				forceUpdate={this.forceStateUpdate}
																			/>
																		) : (
																			<button
																				type="button"
																				className="robo btn btn-success"
																				style={{"position":"relative","border":"0.7px solid #AEAEAE","color":"#99201c","width":"70px","backgroundColor":"rgb(255, 255, 255)","letterSpacing":"0.8px","borderRadius":"3px"}}
																				onClick={() => {
																					item.quantity = 1;
																					addProduct(item);
																					this.forceStateUpdate();
																				}}
																			>
																				ADD
																				<span style={{"position":"absolute","top":"0px","right":"4px"}}>+</span>
																				<Ink duration="500" />
																			</button>
																		)}
																	</React.Fragment>
																) : (
																	<div className="robo text-danger text-item-not-available">
																		{localStorage.getItem("cartItemNotAvailable")}
																	</div>
																)}
															</div>
														</React.Fragment>
													)}
                           </div>
                        </div>
                    </div>
                ))}


                </div>
            </React.Fragment>
        );
    }
}

export default ScrollItems;